/* CoreSectionRouterRenderer.js */

"use strict";

class CoreSectionRouterRenderer {
    constructor(model, logger) {
        this._model = model;
        this._logger = logger;
        this._rootElem = document.createElement("core-section-router-gl");
        this._rootElem.component = this._model;

        //append the modal user feedback component to the section container
        this._rootElem.appendChild(this._model._userFeedbackComponent.renderer.rootElement);

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */

    /********************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */

    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [Promise.resolve()];

        return Promise.all(promArr).then(() => {
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
        });
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        //Shutdown Current Section
        let shutdownProm = this._shutdownSection(this._model.currentSectionDetails).catch((e) => {
            this._logger.error(
                {
                    error: e,
                    nextSectionDetails: this._model.nextSectionDetails,
                    currentSectionDetails: this._model.currentSectionDetails,
                },
                "Shutting down of the previous section FAILED, make sure you don't have a memory leak. Removing from the DOM and moving on."
            );
            this._model.currentSectionDetails.cmpnt.renderer.rootElement.remove();
            //Other than logging a note to check for MEMORY leaks we should act like all worked fine.
            return Promise.resolve();
        });
        let startupProm = this._startupSection(this._model.nextSectionDetails);
        return Promise.all([shutdownProm, startupProm]);
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */

    /*******************************************/
    _renderErrorPane() {}

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */

    /*******************************************/
    _shutdownSection(sectionDetails) {
        if (sectionDetails) {
            let oldCmpnt = sectionDetails.cmpnt;
            let oldElem = oldCmpnt.renderer.rootElement;
            oldElem.classList.remove("current_section");
            oldElem.classList.add("previous_section", "shutting_down");
            let shutDownProm = oldCmpnt.shutdown();
            return shutDownProm.then(() => {
                oldElem.classList.add("shutting_down_complete");
                setTimeout(() => {
                    oldElem.remove();
                }, 50);
            });
        } else {
            return Promise.resolve();
        }
    }

    _startupSection(sectionDetails) {
        if (sectionDetails) {
            let newCmpnt = sectionDetails.cmpnt;
            let newElem = newCmpnt.renderer.rootElement;

            newElem.classList.add("current_section", "starting_up");
            this._rootElem.appendChild(newElem);
            let renderProm = newCmpnt.renderer.render();

            return new Promise((resolve, reject) => {
                renderProm
                    .then(() => {
                        newElem.classList.add("starting_up_complete");
                        setTimeout(() => {
                            newElem.classList.remove("starting_up", "starting_up_complete");
                            resolve();
                        }, 50);
                    })
                    .catch((e) => {
                        this._logger.error(
                            {
                                error: e,
                                nextSectionDetails: this._model.nextSectionDetails,
                                currentSectionDetails: this._model.currentSectionDetails,
                            },
                            "Failed to render the destination Section Component."
                        );
                        reject(e);
                    });
            });
        } else {
            return Promise.reject({
                errorCode: "SectionDetailsMissing",
                errorMsg: "Cannot startup a Section without the Section's details.",
            });
        }
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = CoreSectionRouterRenderer;
